import getConfig from 'next/config';

export const getApiUrl = () => {
  const config = getConfig() || {};
  const serverRuntimeConfig = config.serverRuntimeConfig || {};
  const publicRuntimeConfig = config.publicRuntimeConfig || {};

  if (typeof window === 'undefined') {
    return (
      serverRuntimeConfig.apiUrl ||
      publicRuntimeConfig.apiUrl ||
      process.env.API_URL
    );
  }

  return publicRuntimeConfig.apiUrl || process.env.API_URL;
};
